import React,{useState, useEffect, useRef, useLayoutEffect} from 'react';
import {  useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { COOKIESPREFIX, WEBSITE } from '../config';
import { Scanner } from '@yudiel/react-qr-scanner';
import {clickFacebook, clickIg, insertRedirectRecords, postProgress} from '../services/service'
import AniScreen from '../components/AniScreen'
import Floor from '../components/Floor'
import QRCode from "react-qr-code";
import Lottie from 'lottie-react';
import './qrcode.css'
// import lottie1   from '../lottie/lottie1.json'
import lottie2   from '../lottie/lottie2.json'
//
import PopupControl from '../components/popup/PopupControl'
import { getUserInfo } from '../services/service';
import Nav from '../components/Nav'

const cateToCn = {
  beauty:'美妝',
  sport:'運動塑身',
  family:'家居及育兒',
  fasion:'時尚',
}
const floorInfo = [
  { 
    floorName: '7/F',
    isMission: false,
    isCompleted:false,
    subText: '',
  },
  { 
    floorName: '6/F',
    isMission: false,
    isCompleted:false,
    subText: '',
  },
  { 
    floorName: '5/F',
    isMission: false,
    isCompleted:false,
    subText: '',
  },
  { 
    floorName: '4/F',
    isMission: false,
    isCompleted:false,
    subText: '',
  },
  { 
    floorName: '3/F',
    isMission: false,
    isCompleted:false,
    subText: '',
  },
  { 
    floorName: '2/F',
    isMission: false,
    isCompleted:false,
    subText: '',
  },
  { 
    floorName: '1/F',
    isMission: false,
    isCompleted:false,
    subText: '',
  },
  { 
    floorName: 'G/F',
    isMission: false,
    isCompleted:false,
    subText: 'Pop-up store',
  },
  { 
    floorName: 'B1/F',
    isMission: false,
    isCompleted:false,
    subText: '',
  },
]
const missionFloor = {
  sport: {local1: (floorInfo.length - 1) - 6},
  family: {local1: (floorInfo.length - 1) - 8},
  fasion:{local1: (floorInfo.length - 1) - 3},
  beauty:{local1: (floorInfo.length - 1) - 1}
}
//screens
function App(props) {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies([`@${COOKIESPREFIX}_token`]);
  const [selectedMission, setSelectedMission] = useState(undefined)
  const [popType, setPopType] = useState(null)
  const [scanType, setScanType] = useState(null)
  const [successPop, setSuccessPop] = useState(null)
  const [playAni, setPlayAni] = useState(false)
  const [floorInfoData, setFloorInfoData] = useState(floorInfo)
  const [gameData, setGameData] = useState(undefined)
  const [floorPos, setFloorPos] = useState('bottom')
  const [resultPop, setResultPop] = useState(false)
  const [isNavOpen, setIsNavOpen] = useState(false)
  const [successBgLoaded, setSuccessBgLoaded] = useState(false)
  const [resultQreLoaded, setResultQrLoaded] = useState(false)
  const [isScanLoaded,setIsScanLoaded] = useState(false)
  const [realMissionFloor, setRealMissionFloor] = useState('')
  const floorRef = useRef()
  const routeParams = useParams();

  useEffect(() => {
    console.log(routeParams)
    if(routeParams.prize && gameData?.data?.progress1)setResultPop(true)
  },[routeParams,gameData])
  async function getUserData(){
    const res = await getUserInfo(cookies[`@${COOKIESPREFIX}_token`])
    if(res.data === null || res.errno) {
      removeCookie(`@${COOKIESPREFIX}_token`)
      return navigate('/')
    }
    const user = res.data

    if(!user?.data?.category){
      navigate('/usertype');
      return
    }

    const newData = [...floorInfoData]
    const floorIdx = missionFloor[user?.data.category]
    newData[floorIdx.local1].isMission = [true, 1]
    console.log(newData)
    if(user.data.progress1)newData[floorIdx.local1].isCompleted = true
    setRealMissionFloor(newData[floorIdx.local1].floorName)
    setFloorInfoData(newData)
    setGameData(user)

 
    // if(user.data.progress1) setResultPop(true)
    // if(user.data.progress1 && route?.params?.getPrize) setSuccessPop(true)
  }
  function clickAnchor() {
    var anchor = document.getElementById('target')
    anchor?.scrollIntoView();
    var anchor2 = document.getElementById('main')
    anchor2?.scrollTo(0,0);
  }
  useLayoutEffect(() => {
    if(gameData?.data?.progress1) return () => {}
    const timer = setTimeout(() => clickAnchor(),200)
    return () => clearTimeout(timer)
  },[gameData])
  
  useEffect(() => {
    getUserData()
  },[cookies])
  async function onNewScanResult(result){
    let key = undefined
    key = result[0]?.rawValue?.split('tag=')?.[1]?.split('_')
    if(!key)return;
    const [type, progress] = key
    if(type !== gameData.data.category)return;
    setScanType(null)
    const res = await postProgress(cookies[`@${COOKIESPREFIX}_token`], result[0].rawValue, +progress)
    setGameData(res.data)
    setPopType(null)
    setSuccessPop(true)
  }
  function handleSelect(){
    if(!gameData?.data.progress1 && selectedMission === 1)setPopType(true)
    if(!gameData?.data.progress2 && selectedMission === 2)setPopType(true)
    if(gameData?.data?.progress1) setResultPop(true)
  }
  function handleScrolling(e){
    const bottom = e.target.scrollTop > (e.target.clientHeight*0.442);
    if (bottom) {
      setFloorPos('bottom')
    }else if(e.target.scrollTop === 0){
      setFloorPos('top')
    }else{
      if(floorPos !== 'mid')setFloorPos('mid')
    }
  }
  function handleStartScan(){
    setScanType(true)
  }
  const test = async(isFace) => {
    try{
      const res = await fetch(`/images/share_${gameData?.data?.category}.jpg`);
      const blob = await res.blob();
      const files = [new File([blob], 'photo.jpg', { type: blob.type })];
      if(isFace){
        setTimeout(() => {
          clickFacebook(cookies[`@${COOKIESPREFIX}_token`])
          //window.open(`https://m.facebook.com/sharer/sharer.php?u=${encodeURIComponent(WEBSITE + `/images/share_${gameData?.data?.category}.jpg`)}`, '_blank');
          window.open('https://m.facebook.com', '_blank');
        })
      }else{
        setTimeout(() => {
          clickIg(cookies[`@${COOKIESPREFIX}_token`])
          window.open(`instagram://camera`, '_blank');
        })
        // await navigator.share({
        //     files: files,
        //     title: 'BOC',
        //     url: WEBSITE+`/images/share_${gameData?.data?.category}.jpg`
        // });
      }
    }catch(err){
      console.log(err)
    }
  }
  const handleSelectFloor = (num) => {
    setSelectedMission(num)
  }


  const topRef= useRef(null)
  useLayoutEffect(()=>{
      setTimeout(()=>{
        if(topRef?.current)
          topRef.current.scrollIntoView();},500)
  },[gameData])
  if(!gameData) return <></>
  return (
    <div className="flex flex-col items-center relative w-[100%] h-[100%]">
      <div ref={topRef}/>
      {popType !== null && <div className='absolute bg-[#00000080] w-[100%]' style={{backdropFilter: 'blur(10px)', zIndex:99}}>
        <div className='flex flex-col items-center justify-center w-[100%]'>
          <div className='relative overflow-y-auto w-[100%] h-[100%]' style={{zIndex:99}}>
            <div className='absolute right-[12%] top-[7%] w-[10%] h-[5%]' onClick={() => setPopType(null)}></div>
            <PopupControl popName={gameData.data.category} handleStartScan={handleStartScan}/>
          </div>
        </div>
      </div>}
      {successPop !== null && <div className='absolute bg-[#00000080] w-full min-w-[100vw]' style={{backdropFilter: 'blur(10px)',zIndex:99}}>
        <div className='flex flex-col items-center justify-center w-full min-w-[100vw]'>
          <div onClick={() => setSuccessPop(null)} className='absolute top-[7%] right-[12%] w-[10%] h-[5%]'></div>
          <div className='absolute top-[9%] font-bold text-white text-[21px]'>{realMissionFloor}{cateToCn[gameData.data.category]}</div>
          {console.log(missionFloor[gameData.data.category].local1)}
          <img onLoad={() => setSuccessBgLoaded(true)} src='/images/newnewwinpage.png' className='w-full min-w-[100vw]' style={{objectFit:'contain'}}></img>
          { successBgLoaded && <div className='absolute w-[100%] top-[10%]' style={{zIndex:0}}>
              <Lottie animationData={lottie2} loop={false}/>
          </div>}
          <img src='/images/winmessage.png' className='absolute w-[50%] top-[29%]' style={{objectFit:'contain',zIndex:99}}></img>
          {/* <div className='ml-auto p-2 select-none' onClick={() => setSuccessPop(null)}>X</div> */}
          <div className='absolute h-[6%] w-[75%] top-[71%]'onClick={() => {setSuccessPop(null);setResultPop(true);console.log('asdfads')}}></div>
          <div className='absolute h-[8%] w-[17%] top-[54%] left-[31%]' style={{zIndex:99}}onClick={() => test(true)}></div>
          <div className='absolute h-[8%] w-[17%] top-[54%] left-[52%]' style={{zIndex:99}}onClick={() => test()}></div>
          {/* {(!gameData?.data.progress1 || !gameData?.data.progress2) && <div>{`open image ${gameData?.data.category+(gameData?.data.progress1? '2': '1')}`}</div>}
          {(gameData?.data.progress1 && gameData?.data.progress2) && <div><div onClick={() => setPlayAni(true)}>get prize now</div></div>} */}
        </div>
      </div>}
      {/* scanning */}
      {scanType !== null && <div className='absolute bg-[#00000080] w-full min-w-[100vw]' style={{backdropFilter: 'blur(10px)',zIndex:100}}>
        <img onLoad={() => setTimeout(() => setIsScanLoaded(true), 1000)} src='/images/qrscanbg.jpg' className='w-full min-w-[100vw]' style={{objectFit:"contain"}}></img>
        {isScanLoaded && <div className='h-[100%] w-[100%] flex flex-col absolute top-0 '>
          <div className='absolute w-[40%] h-[6%] top-[73.5%] left-[30%]' onClick={() => setScanType(null)}></div>
          <div className='qr-image-wrapper flex flex-col absolute top-[38%] left-[12%] w-[75%]'>
            <Scanner className="qr-image-wrapper" onScan={(result) => onNewScanResult(result)} styles={{finderBorder:-100}}/>
          </div>
        </div>}
      </div>}
      {/* animation */}
      {/* {playAni && <div className='h-[100%] w-[100%] absolute flex items-center justify-center' style={{backdropFilter: 'blur(10px)',zIndex:101}}>
        <AniScreen />
      </div>} */}
      {/* game result */}
      {resultPop && <div className='absolute bg-[#00000080] w-full min-w-[100vw]' style={{backdropFilter: 'blur(10px)', zIndex:99}}>
        <div className='flex flex-col items-center justify-center w-full min-w-[100vw]'>
            <img onLoad={() => setResultQrLoaded(true)} className='w-full min-w-[100vw]' style={{objectFit:'contain'}} src='/images/resultbg.png'></img>
            {resultQreLoaded && <>
              <div className='absolute top-[20%] font-bold text-[18px] text-[#13365f]'>領取{cateToCn[gameData?.data?.category]}達人專屬禮品</div>
              <div className='absolute top-[25%] border border-[#f4c65c] py-[12px] px-[12px] rounded-xl border-[2px] flex flex-row items-center justify-center' >
                <QRCode value={gameData?._id} fgColor={'#baa05a'} style={{width:'100%'}}/>
              </div>
              <div className='absolute top-[7%] left-[78%] w-[10%] h-[5%]' onClick={() => setResultPop(false)}></div>
              <div className='absolute top-[62%] left-[15%] w-[70%] h-[5%]' onClick={() => {navigate('/info')}}></div>
              <div className='absolute top-[70.5%] left-[15%] w-[70%] h-[5%]' onClick={()=>{
                  insertRedirectRecords('https://www.bochk.com/s/a/sogocard')
                  window.open(`https://www.bochk.com/s/a/sogocard`, '_blank');
              }}/>
             
            </>}
        </div>
      </div>}
      {/* main game */}
      <div id='main' className="flex w-full flex-col items-center relative overflow-y-auto">
        {popType === null && <div onClick={() => setIsNavOpen(true)} className='w-[9%] h-[3%] top-[10%] left-[84%] absolute flex flex-col items-center justify-between' style={{zIndex:98}}>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
        </div>}
        <Nav gameData={gameData} closeNav={() => setIsNavOpen(false)} isNavOpen={isNavOpen} />
        <div className='relative w-full'>
          <img src={`/images/game${gameData?.data?.category}bg.jpg`} className='w-full'/>
          <div style={{zIndex:3}} className='absolute top-0 left-0 w-full h-full px-[0%]'>
            {floorPos !== 'top' ? <img src='/images/floor.png' className='w-[7%] absolute top-[32%] left-[48%]' style={{height:undefined, aspectRatio:58/29}}/> : <img src='/images/greyfloor.png' className='w-[7%] absolute top-[32%] left-[48%]' style={{height:undefined, aspectRatio:58/29}}/>}
            <div ref={floorRef} onScroll={(e) => handleScrolling(e)} className='absolute w-[60%] h-[34%] left-[22%] top-[34%] overflow-y-auto px-[3%] py-[5%] no-scrollbar'>
              {floorInfoData.map((data, i ) => 
                <Floor 
                  handleSetFloor={(num) => handleSelectFloor(num)} 
                  isLast={i === 0} 
                  floorName = {data.floorName} 
                  isMission = {data.isMission?.[0]} 
                  missionNum = {data.isMission?.[1]}
                  isCompleted={data.isCompleted} 
                  subText={data.subText}
                  floorRef = {floorRef}
                />
              )}
            </div>
            {floorPos !== 'bottom' ? <img src='/images/floor.png' className='w-[7%] absolute top-[68.4%] left-[48%] rotate-180' style={{height:undefined, aspectRatio:58/29}}/> : <img src='/images/greyfloor.png' className='w-[7%] absolute top-[68.4%] left-[48%] rotate-180' style={{height:undefined, aspectRatio:58/29}}/>}
            {selectedMission
              ? 
              <img src={'/challenge_colorful.png'} onClick={handleSelect} className='w-[60%] absolute left-[20%] top-[74.5%]'/> 
              : <img src={'/challenge.png'} className='w-[60%] absolute left-[20%] top-[74.5%]'/> 
              }
          </div>
        </div>
      </div>
      {/* {(gameData?.data.progress1) && <div onClick={() => navigate('/result')}>get prize now</div>} */}
    </div>
  );
}

export default App;